






import {Vue, Component, Prop, Emit, Model, Watch} from 'vue-property-decorator';

@Component({
  name: 'MyTabPane',
})
export default class MyTabPane extends Vue {
  @Prop() name: string;
  get isActive() {
    return this.$parent.tabActive === this.name;
  }
}
